<div class="update-overlay">
  <div class="update-card">
    <div class="icon-container">
      <div class="glow"></div>
      <ion-icon name="rocket-outline" class="update-icon"></ion-icon>
    </div>

    <div class="content">
      <h2 class="title">{{ header }}</h2>
      <p class="description">{{ description }}</p>

      <div class="version-comparison">
        <div class="version-info">
          <span class="label">Current</span>
          <span class="value">{{ oldVersionNumber }}</span>
        </div>

        <ion-icon name="arrow-forward-outline" class="arrow"></ion-icon>
        <div class="version-info">
          <span class="label">New</span>
          <span class="value">{{ version }}</span>
        </div>
      </div>
    </div>

    <div class="actions">
      <ion-button expand="block" shape="round" class="update-btn primary-btn" (click)="reloadApp()" *ngIf="isWeb">
        <ion-icon slot="start" name="refresh-outline"></ion-icon>
        Reload to Update
      </ion-button>

      <ion-button expand="block" shape="round" color="success" class="download-btn" (click)="downloadApp()"
        *ngIf="isWeb">
        <ion-icon slot="start" name="cloud-download-outline"></ion-icon>
        Download App (APK)
      </ion-button>

      <ion-button expand="block" shape="round" color="success" class="download-btn" (click)="downloadApp()"
        *ngIf="!isWeb">
        <ion-icon slot="start" name="logo-google-playstore"></ion-icon>
        Update from Play Store
      </ion-button>
      <ion-button expand="block" shape="round" fill="clear" class="later-btn" (click)="onClose()">
        I'll Do It Later
      </ion-button>
    </div>
  </div>
</div>